(() => {
  const PRODUCT_HANDLES = [
    'blank-vintage-black-crop-zip-up-hoodie',
    'blank-black-crop-zip-up-hoodie',
    'blank-grey-crop-zip-up-hoodie',
    'blank-brown-crop-zip-up-hoodie-copy',
    'blank-olive-green-crop-zip-up-hoodie',
    'blank-navy-blue-crop-zip-up-hoodie',
  ];

  const updatePreview = (productInfo) => {
    if (!productInfo || !PRODUCT_HANDLES.includes(productInfo.dataset.productHandle)) return;

    const embroideryField = productInfo.querySelector('[data-custom-embroidery]');
    const colorField = productInfo.querySelector('[data-embroidery-color]');
    const previewTargets = productInfo.querySelectorAll('[data-embroidery-preview]');

    if (!embroideryField || !colorField || !previewTargets.length) return;

    const embroideryText = embroideryField.value.trim().slice(0, 10);
    const previewColor = colorField.selectedOptions[0]?.dataset.previewColor || '#111111';

    embroideryField.value = embroideryText;

    previewTargets.forEach((target) => {
      const previewText = target.querySelector('[data-embroidery-preview-text]');
      if (!previewText) return;

      previewText.textContent = embroideryText;
      previewText.style.setProperty('--embroidery-preview-color', previewColor);
      previewText.style.opacity = embroideryText.length > 0 ? '1' : '0';
      target.style.display = 'flex';
      target.classList.toggle('product__embroidery-preview--visible', embroideryText.length > 0);
    });
  };

  const bindPreview = (productInfo) => {
    if (!productInfo || !PRODUCT_HANDLES.includes(productInfo.dataset.productHandle)) return;
    if (productInfo.dataset.embroideryPreviewBound === 'true') {
      updatePreview(productInfo);
      return;
    }

    const embroideryField = productInfo.querySelector('[data-custom-embroidery]');
    const colorField = productInfo.querySelector('[data-embroidery-color]');

    if (!embroideryField || !colorField) return;

    const boundUpdate = () => updatePreview(productInfo);
    embroideryField.addEventListener('input', boundUpdate);
    colorField.addEventListener('change', boundUpdate);

    productInfo.dataset.embroideryPreviewBound = 'true';
    updatePreview(productInfo);
  };

  const bindAllPreviews = (root = document) => {
    root.querySelectorAll('product-info').forEach(bindPreview);
  };

  window.updateEmbroideryPreviewForSection = (sectionId) => {
    const productInfo = document.getElementById(`MainProduct-${sectionId}`);
    if (!productInfo) return;
    bindPreview(productInfo);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindAllPreviews(), { once: true });
  } else {
    bindAllPreviews();
  }

  document.addEventListener('shopify:section:load', (event) => {
    bindAllPreviews(event.target);
  });
})();
